import type { V1AppConfigGetLoginBrandingResponse } from '@repo/sdk/gen'

/**
 * What the console draws as the product: the instance's runtime branding and
 * nothing else (`web/apps/keycloak-theme/LOGIN-BRANDING.md`).
 *
 * THERE IS NO FALLBACK IDENTITY. The operator publishing nothing, the read
 * failing, or one field being unset all arrive here as an absent value and
 * leave the field absent: no product name, no logo, no mark. Every consumer
 * draws nothing branded for an absent field (no `<img>`, no name, no favicon
 * link), so an unconfigured instance looks unbranded.
 *
 * THE DARK VARIANT FOLLOWS THE LIGHT ONE. A published logo with no reversed
 * twin is drawn on both surfaces, as the login page does. The switch between
 * the two stays the `.dark` class at every call site, never
 * `prefers-color-scheme`.
 */
export function resolveBrand(
	instance?: V1AppConfigGetLoginBrandingResponse['instance']
) {
	const logo = instance?.images.logo?.url
	const logoDark = instance?.images.logoDark?.url
	const mark = instance?.images.mark?.url
	const markDark = instance?.images.markDark?.url

	return {
		// Whether the installation lets an organization or a person have no
		// storage limit; absent or null means no.
		allowUncappedQuotas: instance?.allowUncappedQuotas === true,
		productName: instance?.productName,
		logo: logo ? { light: logo, dark: logoDark ?? logo } : undefined,
		mark: mark ? { light: mark, dark: markDark ?? mark } : undefined,
		favicon: instance?.images.favicon?.url
	}
}
